var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeSincere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7852 14.1605C15.5762 15.0801 16.1614 16.0414 17.1227 16.2504C18.0841 16.4594 19.0454 15.8742 19.2544 14.9547L21.8041 4.00355C22.0131 3.08399 21.4279 2.12263 20.4666 1.91364C19.5052 1.70465 18.5439 2.28982 18.3349 3.20938L15.7852 14.1605Z",
    fill: "url(#paint0_linear_17_124)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0877 15.2464C19.0877 15.2464 15.4513 11.6517 9.01433 13.4491C9.01433 13.4491 5.21069 14.1178 5.41968 16.0405C5.41968 16.0405 5.29429 20.8055 6.92442 23.6478C8.93918 27.0968 16.2089 27.6854 19.8299 23.6478C20.6411 22.7433 20.5642 21.9305 21.0002 20.5C21.0002 19 21.0002 15.5 19.0877 15.2464Z",
    fill: "url(#paint1_linear_17_124)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6075 14.7869C12.7747 15.7482 13.736 16.3334 14.6974 16.1662C15.6588 15.999 16.3275 15.0794 16.1603 14.1181L14.0704 3.08334C13.9032 2.12199 12.9419 1.53681 11.9805 1.704C11.0191 1.8712 10.3504 2.79076 10.5594 3.75212L12.6075 14.7869Z",
    fill: "url(#paint2_linear_17_124)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6075 14.7869C12.7747 15.7482 13.736 16.3334 14.6974 16.1662C15.6588 15.999 16.3275 15.0794 16.1603 14.1181L14.0704 3.08334C13.9032 2.12199 12.9419 1.53681 11.9805 1.704C11.0191 1.8712 10.3504 2.79076 10.5594 3.75212L12.6075 14.7869",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21185 14.2442C5.08646 13.2828 5.79703 12.4051 6.80019 12.2797H6.84198C7.80334 12.1961 8.7229 12.8649 8.8065 13.868L9.09909 16.5849C9.22448 17.5463 8.51391 18.424 7.51076 18.5494H7.46896C6.4658 18.633 5.58804 17.9642 5.50444 16.9611L5.21185 14.2442Z",
    fill: "url(#paint3_linear_17_124)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21185 14.2442C5.08646 13.2828 5.79703 12.4051 6.80019 12.2797H6.84198C7.80334 12.1961 8.7229 12.8649 8.8065 13.868L9.09909 16.5849C9.22448 17.5463 8.51391 18.424 7.51076 18.5494H7.46896C6.4658 18.633 5.58804 17.9642 5.50444 16.9611L5.21185 14.2442",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59393 12.2797C8.46854 11.3183 9.17911 10.4405 10.1823 10.3151H10.2241C11.2272 10.2315 12.105 10.9003 12.1886 11.9035L12.4812 14.6204C12.6066 15.5817 11.896 16.4595 10.8928 16.5849H10.851C9.84788 16.6685 8.97012 15.9997 8.88652 14.9965L8.59393 12.2797Z",
    fill: "url(#paint4_linear_17_124)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59393 12.2797C8.46854 11.3183 9.17911 10.4405 10.1823 10.3151H10.2241C11.2272 10.2315 12.105 10.9003 12.1886 11.9035L12.4812 14.6204C12.6066 15.5817 11.896 16.4595 10.8928 16.5849H10.851C9.84788 16.6685 8.97012 15.9997 8.88652 14.9965L8.59393 12.2797",
    stroke: "white",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91507 17.9648C7.91823 17.8394 8.58701 17.0035 8.50341 16.0003L8.21082 13.2834C8.16902 13.0326 8.04363 12.74 7.91823 12.4893C8.54521 12.7818 8.7542 13.2834 8.8378 13.8686L9.13038 16.5855C9.25578 17.5469 8.54521 18.4246 7.58385 18.5082C6.87328 18.5918 6.2045 18.2156 5.87012 17.6722C6.12091 17.8812 6.49709 18.0066 6.91507 17.9648Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2533 16.0001C11.2565 15.8747 11.967 15.0388 11.8416 14.0774L11.5491 11.3605C11.5073 11.1097 11.3819 10.7753 11.2565 10.5663C11.8416 10.9007 12.0924 11.4023 12.176 11.9875L12.4686 14.7044C12.594 15.6657 11.8834 16.5017 10.8803 16.6271H10.8385C10.1279 16.7107 9.45914 16.3345 9.12476 15.7911C9.45914 15.9583 9.83533 16.0419 10.2533 16.0001Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4924 17.8808C15.486 16.9195 10.93 18.5914 11.8496 22.7712C11.8496 18.4242 15.7786 17.6718 17.4924 17.8808Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7347 13.5756C15.2717 12.6978 15.021 14.0771 12.5549 14.1607C11.4681 14.2025 11.0083 16.4178 12.6385 17.212C14.8956 18.3406 15.0628 16.7522 15.6479 17.3792C16.2331 18.048 16.7765 18.1734 17.2781 18.9257C17.6542 19.4691 20.4547 18.6331 20.7473 17.5046C21.2907 15.2893 18.9918 14.9549 16.7347 13.5756Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9129 13.9515C15.4082 13.0738 15.1156 14.4531 12.5659 14.5367C11.4373 14.5785 10.9357 16.8774 12.6495 17.7134C14.9902 18.8837 15.1992 17.2118 15.7425 17.8806C16.3695 18.5493 16.9129 18.7165 17.4563 19.5107C17.8325 20.0959 16.8293 22.2694 16.8293 22.2694C16.8293 22.2694 19.7134 24.3175 20.2986 23.1471C21.3853 20.9736 21.0927 19.3017 21.0509 18.0478C20.9673 15.0801 19.2954 15.3727 16.9129 13.9515Z",
    fill: "url(#paint5_linear_17_124)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9129 13.9515C15.4082 13.0738 15.1156 14.4531 12.5659 14.5367C11.4373 14.5785 10.9357 16.8774 12.6495 17.7134C14.9902 18.8837 15.1992 17.2118 15.7425 17.8806C16.3695 18.5493 16.9129 18.7165 17.4563 19.5107C17.8325 20.0959 16.8293 22.2694 16.8293 22.2694C16.8293 22.2694 19.7134 24.3175 20.2986 23.1471C21.3853 20.9736 21.0927 19.3017 21.0509 18.0478C20.9673 15.0801 19.2954 15.3727 16.9129 13.9515",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_124",
    x1: 16.3087,
    y1: 0.563733,
    x2: 24.7811,
    y2: 1.70916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_124",
    x1: 6.89867,
    y1: 11.6952,
    x2: 26.8269,
    y2: 19.1003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17_124",
    x1: 11.0461,
    y1: 0.359215,
    x2: 18.9311,
    y2: 1.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17_124",
    x1: 5.56049,
    y1: 11.7029,
    x2: 10.8847,
    y2: 12.7628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17_124",
    x1: 8.94257,
    y1: 9.73838,
    x2: 14.2668,
    y2: 10.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17_124",
    x1: 12.4243,
    y1: 12.7676,
    x2: 24.7749,
    y2: 16.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeSincere);
export default __webpack_public_path__ + "static/media/beSincere.187fe9f13f34abf9ad107807ba63ace9.svg";
export { ForwardRef as ReactComponent };